import { createAsyncAction, normalizeHelper } from '../../utils/asyncHelpers';
import {
  METERING_POINT_FETCH,
  METERING_POINT_UPDATE,
  METERING_POINT_AGR_DATA_FETCH,
  CONSUMPTION_METERING_POINT_UPDATE,
  METERING_POINT_ACTIVATION,
  METERING_POINT_REVIEW_FETCH,
  METERING_POINT_GENERATE_GO,
} from '../../constants/meteringPointActionTypes';
import {
  measurement as meteringPointSchema,
  meteringPointReviewSchema,
} from '../../schemas';
import {
  meteringPointUpdate,
  meteringPointFetch,
  meteringPointAgrDataFetch,
  consumptionPointUpdateOrAdd,
  activatePointPut,
  deactivatePointPut,
  meteringReviewFetch,
  pointGenerateGo,
} from '../actionHelpers/endpoints';
export const fetchMeteringPoint = createAsyncAction(
  METERING_POINT_FETCH,
  meteringPointFetch,
  normalizeHelper(meteringPointSchema)
);

export const updateMeteringPoint = createAsyncAction(
  METERING_POINT_UPDATE,
  meteringPointUpdate,
  normalizeHelper(meteringPointSchema)
);

export const fetchMeteringPointAgrData = createAsyncAction(
  METERING_POINT_AGR_DATA_FETCH,
  meteringPointAgrDataFetch
);

export const activateMeteringPoint = createAsyncAction(
  METERING_POINT_ACTIVATION,
  activatePointPut,
  normalizeHelper(meteringPointSchema)
);

export const fetchMeteringPointReview = createAsyncAction(
  METERING_POINT_REVIEW_FETCH,
  meteringReviewFetch,
  normalizeHelper([meteringPointReviewSchema])
);

export const deactivateMeteringPoint = createAsyncAction(
  METERING_POINT_ACTIVATION,
  deactivatePointPut,
  normalizeHelper(meteringPointSchema)
);

export const generateMeteringPointsGOs = createAsyncAction(
  METERING_POINT_GENERATE_GO,
  pointGenerateGo,
  normalizeHelper(meteringPointSchema)
);

export const updateConsumptionPoint = createAsyncAction(
  CONSUMPTION_METERING_POINT_UPDATE,
  consumptionPointUpdateOrAdd,
  normalizeHelper(meteringPointSchema)
);
